import { render, staticRenderFns } from "./InputCustom.vue?vue&type=template&id=1f0d8dca&"
import script from "./InputCustom.vue?vue&type=script&lang=js&"
export * from "./InputCustom.vue?vue&type=script&lang=js&"
import style0 from "./InputCustom.vue?vue&type=style&index=0&id=1f0d8dca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports